import { useEffect, useState } from "react";

const generateRandomNumber = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

const BrokerPriceLadderNQ = () => {
  const initialPrices = [
    20934.00, 20934.25, 20934.50, 20934.75, 20935.00, 20935.25, 20935.50, 20935.75, 20936.00, 20936.25,
    20936.50, 20936.75, 20937.00, 20937.25, 20937.50, 20937.75, 20938.00, 20938.25, 20938.50, 20938.75,
    20939.00, 20939.25, 20939.50, 20939.75, 20940.00, 20940.25, 20940.50, 20940.75, 20941.00, 20941.25
];

  const [ladderData, setLadderData] = useState(
    initialPrices.map((price, index) => ({
      price,
      bid: index > 14 && index < 20 ? generateRandomNumber(50, 500) : null,  // Bids for rows in a specific range
      ask: index >= 5 && index <= 10 ? generateRandomNumber(50, 500) : null,  // Asks for rows in a specific range
      vap: generateRandomNumber(5000, 25000),
    }))
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setLadderData((prevData) =>
        prevData.map((row, index) => ({
          ...row,
          bid: index > 12 && index < 22 ? generateRandomNumber(50, 500) : null,
          ask: index >= 5 && index <= 12 ? generateRandomNumber(50, 500) : null,
        }))
      );
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="text-2xs ">
    <div className="flex bg-gray-800 text-white ">
      {/* Left Control Panel */}
      <div className="w-20 bg-gray-900 p-0.5 flex flex-col items-center">
        <div className="text-2xs font-semibold mb-2">NQ Dec24</div>
        <select className="w-10/12 bg-gray-800 text-2xs mb-2 p-1 rounded">
          <option>12345aa</option>
        </select>
        <div className="flex items-center mb-2">
          <input type="checkbox" className="form-checkbox text-green-400 mr-2" />
          <span className="text-2xs">Filter</span>
        </div>
        <select className="w-10/12 bg-gray-800 text-2xs mb-2 p-1 rounded">
          <option>Limit</option>
        </select>
        <select className="w-10/12 bg-gray-800 text-2xs mb-2 p-1 rounded">
          <option>Day</option>
        </select>
        <button className="w-10/12 bg-blue-700 text-2xs py-1 rounded mb-2">40</button>
        <div className="grid grid-cols-3 gap-0.5 mb-2">
          {[1, 5, 10, 50, 100].map((num) => (
            <button key={num} className="bg-gray-700 text-2xs p-0.5 rounded">{num}</button>
          ))}
          <button className="bg-gray-700 text-2xs p-0 rounded">CLR</button>
        </div>
        <button className="w-10/12 bg-red-700 text-2xs py-1 rounded mb-2">CXL S</button>
        <button className="w-10/12 bg-red-700 text-2xs py-1 rounded mb-2">CXL All</button>
        <button className="w-10/12 bg-blue-700 text-2xs py-1 rounded">CXL B</button>
      </div>

      {/* Main Price Ladder Section */}
      <div className="flex-1">
        {/* Header with H:, L:, O:, V: */}
        <div className="flex justify-between items-center bg-gray-700 p-2 text-2xs font-semibold">
          <span className="text-green-400">+19.50</span>
          <div className="text-right">
            <p>H: <span className="text-green-400">3424.00</span> O: <span className="text-white">3398.75</span></p>
            <p>L: <span className="text-red-400">3393.50</span> V: <span className="text-white">1008719</span></p>
          </div>
        </div>

        {/* Price Ladder Table */}
        <table className="w-full text-center text-2xs table-fixed border-collapse">
          <thead>
            <tr className="bg-gray-700 text-2xs font-semibold">
              <th className="w-1/4">Bids</th>
              <th className="w-1/3">Price</th>
              <th className="w-1/4">Asks</th>
              <th className="w-1/3">VAP</th>
            </tr>
          </thead>
          <tbody>
            {ladderData.map((row, index) => (
              <tr key={index} className={index % 2 === 0 ? "bg-gray-800" : "bg-gray-900"}>
                {/* Bids column */}
                <td className={row.bid !== null ? "bg-blue-600 py-1 border-gray-950 border" : "bg-blue-800 border-gray-950 border"}>
                  {row.bid !== null ? <span className="px-2 py-1">{row.bid}</span> : ""}
                </td>
                {/* Price column */}
                <td className="py-1 text-white">{row.price.toFixed(2)}</td>
                {/* Asks column */}
                <td className={row.ask !== null ? "bg-red-600 py-1 border-gray-950 border" : "bg-red-800 border-gray-950 border"}>
                  {row.ask !== null ? <span className="px-2 py-1">{row.ask}</span> : ""}
                </td>
                {/* VAP column with left-aligned bar */}
                <td className="py-1 flex items-center">
                  <div className="h-2 bg-gray-400" style={{ width: `${(row.vap / 25000) * 100}%` }}></div>
                  <span className="ml-2 text-2xs">{row.vap}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
    </div>
  );
};

export default BrokerPriceLadderNQ;
